import { useState } from 'react';
import { InfoDialogUI } from '../../components/InfoDialog/InfoDialogUI';
import { WarningContentInfoIcon } from '../../assets/icons';
import { useUserContext } from '../../contexts/UserContext';
import { TalkToSalesBookingModal } from '../TalkToSalesBooking/TalkToSalesBookingModal';
import styles from './FreeTrialExpiredPopup.module.scss';

// Blocks the app once the free trial has expired; reappears until upgraded off Freemium.
// CTA opens the same rep-matched booking modal as the trial banner.
export default function FreeTrialExpiredPopup() {
  const { freeTrialInfo } = useUserContext();
  const [showBooking, setShowBooking] = useState(false);

  const show = Boolean(freeTrialInfo?.isFreeTrialStarted && freeTrialInfo?.isFreeTrialExpired);

  if (!show) return null;

  return (
    <>
      <InfoDialogUI
        show={show}
        hideTitle
        size="md"
        buttonText="Schedule an Upgrade Call"
        onButtonClick={() => setShowBooking(true)}>
        <div className={styles.expiredPopup}>
          <div className={styles.iconCircle}>
            <WarningContentInfoIcon />
          </div>
          <h3>Upgrade Your Subscription</h3>
          <p>Your free trial has ended. Upgrade your subscription to continue creating models, managing projects, and collaborating with your team. Our sales experts are here to help you select the best plan.</p>
        </div>
      </InfoDialogUI>
      <TalkToSalesBookingModal open={showBooking} onClose={() => setShowBooking(false)} />
    </>
  );
}
